
/* eslint-disable @next/next/no-img-element */
// libraries
import React from 'react';
// utils
import styles from './Depoimentos2.module.css';

function VideoPlayer(videoUrl: string) {
    let videoId;
    try {
        if (videoUrl.includes("youtube.com/watch?v=")) {
            videoId = new URL(videoUrl).searchParams.get("v") || "";
        } else if (videoUrl.includes("youtu.be/")) {
            videoId = videoUrl.split("youtu.be/")[1].split("?")[0];
        }
    } catch (error) {
        videoId = false;
    }

    return (
        videoUrl.includes("youtu") && videoId ?
            <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title="Depoimento"
                className={styles.videoPlayer}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
            :
            <iframe
                src={videoUrl}
                title="Depoimento"
                className={styles.videoPlayer}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
    );
}

const CardDepoimento2: React.FC<{
    slide: any;
    site: any;
    i: any;
}> = ({ slide, site, i }) => {
    // constants
    const GetPhoto = slide?.cliente?.foto;

    return (
        <div className={styles.testimonialWrapper} key={i}>
            <div className={styles.card}>
                <div className={styles.quoteIconStart}>
                    <svg width="32" height="26" viewBox="0 0 24 20" fill="none">
                        <path d="M0 20V10C0 4.5 4.5 0 10 0v5c-2.75 0-5 2.25-5 5v1c0.75-0.5 1.5-1 2.5-1 2.75 0 5 2.25 5 5V20H0zm12.5 0V10c0-5.5 4.5-10 10-10v5c-2.75 0-5 2.25-5 5v1c0.75-0.5 1.5-1 2.5-1 2.75 0 5 2.25 5 5V20H12.5z" fill="#333"/>
                    </svg>
                </div>
                
                <div className={styles.content}>
                    <p className={styles.testimonial}>
                        {slide?.depoimento}
                    </p>
                </div>

                <div className={styles.quoteIconEnd}>
                    <svg width="32" height="26" viewBox="0 0 24 20" fill="none" style={{ transform: 'rotate(180deg)' }}>
                        <path d="M0 20V10C0 4.5 4.5 0 10 0v5c-2.75 0-5 2.25-5 5v1c0.75-0.5 1.5-1 2.5-1 2.75 0 5 2.25 5 5V20H0zm12.5 0V10c0-5.5 4.5-10 10-10v5c-2.75 0-5 2.25-5 5v1c0.75-0.5 1.5-1 2.5-1 2.75 0 5 2.25 5 5V20H12.5z" fill="#333"/>
                    </svg>
                </div>
            </div>

            {slide?.youtube && slide?.youtube.includes("yout") ? (
                <div className={styles.videoContainer}>
                    {VideoPlayer(slide?.youtube)}
                </div>
            ) : (
                <div className={styles.clientInfo}>
                    <div className={styles.avatar}>
                        {GetPhoto ? (
                            <img 
                                src={GetPhoto} 
                                alt="Cliente" 
                                className={styles.avatarImage}
                            />
                        ) : (
                            <div className={styles.avatarPlaceholder}>
                                {slide?.cliente?.nome?.charAt(0) || 'C'}
                            </div>
                        )}
                    </div>
                    <div className={styles.clientDetails}>
                        <p className={styles.clientName} style={{color: site?.cor2}}>
                            {slide?.cliente?.nome}
                        </p>
                        {slide?.cliente?.profissao && (
                            <p className={styles.clientProfession}>
                                {slide?.cliente?.profissao}
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CardDepoimento2;
